import React, { useState } from 'react';

import LoadingContext from '../contexts/loading';

const LoadingProvider = ({ children }) => {
  const showSpinner = () =>
    // eslint-disable-next-line no-use-before-define
    setLoading(prevState => ({
      ...prevState,
      isSpinnerShown: true,
    }));

  const hideSpinner = () =>
    // eslint-disable-next-line no-use-before-define
    setLoading(prevState => ({
      ...prevState,
      isSpinnerShown: false,
    }));

  const loadingState = {
    isSpinnerShown: false,
    hideSpinner,
    showSpinner,
  };

  const [loading, setLoading] = useState(loadingState);

  return (
    <LoadingContext.Provider value={loading}>
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
